const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持4K超清分辨率，画面细腻栩栩如生，每一帧都是视觉享受。多档清晰度自由切换，适配不同网络环境。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速播放',
    desc: '智能CDN加速与多线路切换技术，点击即播无需等待。分布式服务器覆盖，全国畅享高速观影体验。',
  },
  {
    icon: 'ri-advertisement-line',
    title: '无广告纯净',
    desc: '全程零广告打扰，播放前、播放中、播放后均无任何广告植入。纯净观影环境，沉浸式体验每一部作品。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '完美适配手机、平板、电脑全平台。网页版即开即看，APP支持离线缓存，追剧记录云端同步，随时续看。',
  },
  {
    icon: 'ri-movie-2-line',
    title: '海量片库',
    desc: '收录超12万部影视资源，覆盖国产剧、韩剧、美剧、日剧、动漫、综艺等全品类。每天同步更新，追剧永不断档。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-20 px-4 md:px-6 bg-background-950">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">平台特色</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className="group p-5 md:p-6 rounded-2xl bg-background-800/20 hover:bg-background-800/40 border border-background-700/20 hover:border-accent-500/20 transition-all"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-500/10 flex items-center justify-center mb-4 group-hover:bg-accent-500/20 transition-colors">
                <i className={`${item.icon} text-accent-400 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-100 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}